import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getNotif, updateRecentStatus } from '../store/actions/userAction'

import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { Icon } from '@iconify/react';
import clockFill from '@iconify/icons-eva/clock-fill';

import {
    Typography,
    Grid,
    Box,
} from '@material-ui/core';
import {
    List,
    ListItemText,
    ListItemButton
} from '@mui/material';
import Menubar from '../components/Menubar';
import { makeStyles } from '@material-ui/core/styles';
import env from '../env'
const drawerWidth = 240;
const { io } = require("socket.io-client");

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  contentNotif : {
    paddingTop: "7%",
    paddingLeft: "20%",
    backgroundColor: "#e8e8e8",
    paddingRight: "5%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "0",
      paddingRight: "0"
    },
  },
  gridNotifCategory : {
    background: '#fff',
    marginLeft: "1rem",
    marginBottom: "3rem",
    padding: '1rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
}));

function renderContent(notification) {
    const title = (
      <Typography variant="subtitle2">
        {notification.title}
        <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
          &nbsp; {(notification.content)}
        </Typography>
      </Typography>
    );
    
    return { title }
}  

NotificationItem.propTypes = {
    notification: PropTypes.object.isRequired
};
  
function NotificationItem({ notification }) {
    const { title } = renderContent(notification);
  
    return (
      <ListItemButton
        to="#"
        disableGutters
        component={RouterLink}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(notification.state === 'unread' && {
            bgcolor: 'action.selected'
          })
        }}
      >
        <ListItemText
          primary={title}
          secondary={
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: 'flex',
                alignItems: 'center',
                color: 'text.disabled'
              }}
            >
              <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
              {formatDistanceToNow(new Date(notification.createdAt))}
            </Typography>
          }
        />
      </ListItemButton>
    );
}
  

const NotificationList = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const [notifications, setNotifications] = useState(null);
    
    useEffect(() => {
      dispatch(getNotif())
      dispatch(updateRecentStatus())
    }, [dispatch])
    
    const notif = useSelector(state => state.userReducer.notif)
    
    notifications?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const newNotif = notifications?.filter(notification => { return notification.isRecent === true })
    const olderNotif = notifications?.filter(notification => { return notification.isRecent === false })

    const socket = io(env.REACT_APP_BE_URL, {
      withCredentials: true,
      extraHeaders: {
        "my-custom-header": "abcd"
      }
    });
  
    socket.on("updateState", data => {
      setNotifications(data)
    });
    
    useEffect(() => {
      setNotifications(notif)
    }, [notif])
  
    return (
      <React.Fragment>
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentNotif}>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.gridNotifCategory}> 
                <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "5px"}}>Latest</p>
                {
                  newNotif?.length !== 0 ?
                  <List
                    disablePadding
                    >
                    {newNotif?.map((notification) => (
                      <NotificationItem key={notification._id} notification={notification} />
                    ))}
                  </List>
                  :
                  <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                  &nbsp; {('Empty')}
                  </Typography>
                }
            </Grid>
            <Grid item xs={12} md={12} className={classes.gridNotifCategory}> 
                <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "5px"}}>Latest 30 days</p>
                {
                  olderNotif?.length !== 0 ?
                  <List
                    disablePadding
                    >
                    {olderNotif?.map((notification) => (
                      <NotificationItem key={notification._id} notification={notification} />
                    ))}
                  </List>
                  :
                  <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                  &nbsp; {('Empty')}
                  </Typography>
                }
            </Grid>
          </Grid>
        </Grid>
    </React.Fragment>
  )
}

export default NotificationList
